import React, { useEffect } from 'react'
import { formatDate } from 'src/common/utils'
import PropTypes from 'prop-types'
import RichText from '../RichText'
import styles from './index.module.scss'

const DocumentPageLayout = ({
  title,
  lastUpdated,
  subtitle,
  content,
  locale,
}) => {
  useEffect(() => {
    const hash = window.location.hash
    if (hash) {
      const el = document.querySelector(hash.split('/')[0])
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [])

  return (
    <div
      className="mx-4 my-10 max-w-screen-sm md:mx-auto"
      data-testid="document-pages"
    >
      <div className="max-w-4xl px-4 text-gray-500 sm:m-auto lg:px-0">
        <div className="text-center">
          <h1
            className="mb-3 text-4xl leading-11 text-blue-700"
            data-testid="title"
          >
            {title}
          </h1>
          {lastUpdated ? (
            <p
              className={`text-sm ${subtitle ? 'my-4' : 'mt-8 mb-2 text-left'}`}
              data-testid="last-updated"
            >
              <span
                className={`mr-2 ${
                  subtitle ? 'underline' : 'font-bold no-underline'
                }`}
              >
                {locale === 'es' ? 'Última actualización:' : 'Last Updated:'}
              </span>
              {formatDate(lastUpdated, {
                locale: locale === 'es' ? 'es-ES' : 'en-US',
              })}
            </p>
          ) : (
            ''
          )}
          {subtitle ? (
            <p
              className="my-3 text-center text-2xl font-normal text-blue-700"
              data-testid="subtitle"
            >
              {subtitle}
            </p>
          ) : (
            ''
          )}
        </div>
        <div className="text-sm" data-testid="content-section">
          <RichText contentData={content} className={styles.richText} />
        </div>
      </div>
    </div>
  )
}

DocumentPageLayout.defaultProps = {
  title: '',
  lastUpdated: undefined,
  subtitle: '',
  content: {},
  locale: 'en',
}

DocumentPageLayout.propTypes = {
  title: PropTypes.string,
  lastUpdated: PropTypes.string,
  subtitle: PropTypes.string,
  content: PropTypes.object,
  locale: PropTypes.string,
}
export default DocumentPageLayout
